export default {
  SET_CURRENT_CHAT: (state, payload) => (state.currentChat = payload),
  SET_OVERLOAD_MESSAGES: (state, payload) => (state.overloadMessages = payload),

  SET_CHATS: (state, payload) => (state.chats = payload),
  SET_TOTAL_CHATS_LENGTH: (state, payload) => (state.total_chats_length = payload)
}
